<template>
  <SubMenuTabTemplate v-if="show" :icon="routeIcon(node)" :text="routeDisplayName(node)" :hide="hide"
    :to="{ name: node.name, params: $route.params }">
  </SubMenuTabTemplate>
</template>


<script>
import SubMenuTabTemplate from "@/components/SingleUse/ComponentOverrides/submenu/SubMenuTab_template.vue";
import ContractMixin from "@/helpers/Mixins/ContractMixin";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "SubMenuTab_ContractOrders",
  props: {
    node: Object,
    hide: Boolean,
  },
  components: {
    SubMenuTabTemplate,
  },
  mixins: [ContractMixin],

  data() {
    return {
      entityName: EntityNames.Contract
    };
  },

  methods: {},

  computed: {
    loading() {
      return this.$store.getters["entitycontainerstore/getEntityLoading"](this.entityName);
    },

    contract: {
      get() {
        return this.$store.getters["entitycontainerstore/getEntity"](this.entityName);
      },
      set(obj) {
        this.$store.dispatch("entitycontainerstore/setEntity", { entityName: this.entityName, entity: obj });
      },
    },

    show() {
      return !this.loading && this.contract && this.contractTypeHasOrders(this.contract.ContractTypeId);
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>